import React from "react";
import ReactDOM from "react-dom";
import ReactGA from "react-ga";
import App from "./App";
import AuthenticationError from "./components/AuthenticationError";
import Loading from "./components/Loading";
import AuthContext from "./context/AuthContext";

const trackingId = "";

const Index = () => {
  let token;
  var urlParams = new URLSearchParams(window.location.search);

  const login = () => {
    window.location.href = process?.env?.REACT_APP_AUTH_URL || "";
  };

  if (urlParams.has("token")) {
    token = urlParams.get("token");
    window.sessionStorage.setItem(
      "entreCompToken",
      JSON.stringify({ token: token })
    );
    // @ts-ignore
    window.location = ".";
    return null;
  } else {
    token = JSON.parse(
      // @ts-ignore
      window.sessionStorage.getItem("entreCompToken")
    );
    console.info("Initializing GA");
    ReactGA.initialize(trackingId);
    ReactGA.set({
      userId: token?.email ?? "not-known",
    });
  }

  if (process.env.NODE_ENV !== "production") {
    console.error(
      "if you're getting 401s, you probably need to update this token with another one, based on the appId in auth.php"
    );

    token = {
      username: "",
      token: "7f18ca39-fea7-41d6-895e-acd71154db54",
      experatinTime: "",
      RefreshToken: "",
    };

    sessionStorage.setItem(
      "entreCompToken",
      JSON.stringify(token) //generate with student's email, impersonation doesn't work on localhost
    );
  }

  return (
    <AuthContext.Provider
      value={{
        token: token?.token,
        email: token?.username,
        refreshToken: token?.refreshToken,
        expirationTime: token?.experatinTime,
        groups: token?.groups,
        login: login,
      }}
    >
      <App />
    </AuthContext.Provider>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <Index />
  </React.StrictMode>,
  document.getElementById("root")
);
